import { arrayUnique } from './../../utils/sharedHelpers';
import { CardEvent } from 'src/store/events/types';
import { Reducer } from 'redux';
import { EventState, EventActionTypes } from './types';
import * as moment from 'moment';
import { SharedActionTypes } from '../shared/types';

const initialState: EventState = {
  data: {
    byId: {},
    allIds: [],
    byWeekId: {},
    nextDay: [],
    bySeasonId: {},
    byCardGroup: []
  },
  errors: undefined,
  loading: false,
  successful: false,
  loadingWeek: -1
};

const reducer: Reducer<EventState> = (state = initialState, action) => {
  switch (action.type) {
    case EventActionTypes.CREATE_REQUEST:
    case EventActionTypes.FETCH_REQUEST: {
      return { ...state, loading: true };
    }
    case EventActionTypes.FETCH_WEEK_REQUEST: {
      return { ...state, loading: true, loadingWeek: action.payload };
    }
    case EventActionTypes.FETCH_SUCCESS: {
      const events = action.payload.data;
      const weekId = action.payload.weekId;

      const byId = {};
      const allIds: number[] = [];
      const byWeekId: { [id: number]: { [day: number]: number[] } } = {};

      const weekDays: { [day: number]: number[] } = {};

      events.sort((a: CardEvent, b: CardEvent) => {
        const aDate = new Date(a.begins);
        const bDate = new Date(b.begins);
        return aDate > bDate ? 1 : aDate < bDate ? -1 : 0;
      });

      events.forEach((el: CardEvent) => {
        byId[el.id] = el;
        allIds.push(el.id);
        if (weekDays[moment(el.begins).isoWeekday() - 1] === undefined) {
          weekDays[moment(el.begins).isoWeekday() - 1] = [];
        }
        weekDays[moment(el.begins).isoWeekday() - 1].push(el.id);
      });

      byWeekId[weekId] = weekDays;

      return {
        ...state,
        data: {
          ...state.data,
          byId: { ...state.data.byId, ...byId },
          allIds: arrayUnique(state.data.allIds.concat(allIds)),
          byWeekId: { ...state.data.byWeekId, ...byWeekId }
        },
        loading: false,
        loadingWeek: initialState.loadingWeek
      };
    }
    case EventActionTypes.FETCH_SEASON_SUCCESS: {
      const { events, seasonId } = action.payload;

      const byId = {};
      const allIds: number[] = [];
      const bySeasonId: { [id: number]: number[] } = {};

      events.forEach((el: CardEvent) => {
        byId[el.id] = el;

        allIds.push(el.id);
      });

      bySeasonId[seasonId] = allIds;

      return {
        ...state,
        data: {
          ...state.data,
          byId: { ...state.data.byId, ...byId },
          allIds: arrayUnique(state.data.allIds.concat(allIds)),
          bySeasonId: { ...state.data.bySeasonId, ...bySeasonId }
        },
        loading: false
      };
    }
    case EventActionTypes.FETCH_ALL_SUCCESS: {
      const events = action.payload;

      const byId = {};
      const allIds: number[] = [];
      const byWeekId: { [id: number]: { [day: number]: number[] } } = {};

      const weekDays: { [day: number]: number[] } = {};

      events.forEach((el: CardEvent) => {
        const begins = moment(el.begins);
        const weekId = begins.year() + begins.isoWeek();
        byId[el.id] = el;
        allIds.push(el.id);
        if (weekDays[moment(el.begins).isoWeekday() - 1] === undefined) {
          weekDays[moment(el.begins).isoWeekday() - 1] = [];
        }
        weekDays[moment(el.begins).isoWeekday() - 1].push(el.id);
        byWeekId[weekId] = { ...byWeekId[weekId], ...weekDays };
      });

      return {
        ...state,
        data: {
          ...state.data,
          byId: { ...state.data.byId, ...byId },
          allIds: arrayUnique(state.data.allIds.concat(allIds)),
          byWeekId: { ...state.data.byWeekId, ...byWeekId }
        },
        loading: false
      };
    }
    case EventActionTypes.FETCH_SINGLE_SUCCESS: {
      const event = action.payload;

      const byId = { ...state.data.byId };
      const allIds: number[] = [];

      const id = event.id;

      console.log(event);

      byId[id] = { ...byId[id], ...event };
      allIds.push(event.id);

      return {
        ...state,
        data: {
          ...state.data,
          byId,
          allIds: arrayUnique(state.data.allIds.concat(allIds))
        },
        loading: false
      };
    }
    case EventActionTypes.HIDE_EVENT:
    case EventActionTypes.UNHIDE_EVENT: {
      const events = action.payload;

      const event = events[0];

      const byId = { ...state.data.byId };
      const allIds: number[] = [];

      const id = event.id;

      console.log(event);

      byId[id] = { ...byId[id], ...event };
      allIds.push(event.id);

      return {
        ...state,
        data: {
          ...state.data,
          byId,
          allIds: arrayUnique(state.data.allIds.concat(allIds))
        },
        loading: false
      };
    }
    case EventActionTypes.FETCH_DAILY_EVENTS: {
      const events = action.payload;

      const byId = {};
      const allIds: number[] = [];
      const byWeekId: { [id: number]: { [day: number]: number[] } } = {};

      const weekDays: { [day: number]: number[] } = {};

      events.forEach((el: CardEvent) => {
        const begins = moment(el.begins);
        const weekId = begins.year() + begins.isoWeek();
        byId[el.id] = el;
        allIds.push(el.id);
        if (weekDays[moment(el.begins).isoWeekday() - 1] === undefined) {
          weekDays[moment(el.begins).isoWeekday() - 1] = [];
        }
        weekDays[moment(el.begins).isoWeekday() - 1].push(el.id);
        byWeekId[weekId] = { ...byWeekId[weekId], ...weekDays };
      });

      return {
        ...state,
        data: {
          ...state.data,
          byId: { ...state.data.byId, ...byId },
          allIds: arrayUnique(state.data.allIds.concat(allIds)),
          byWeekId: { ...state.data.byWeekId, ...byWeekId },
          nextDay: allIds
        },
        loading: false
      };
    }
    case EventActionTypes.CREATE_ERROR:
    case EventActionTypes.FETCH_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload,
        loadingWeek: initialState.loadingWeek
      };
    }
    case EventActionTypes.CREATE_SUCCESS: {
      return { ...state, loading: false };
    }
    case EventActionTypes.FETCH_EVENT_CARDGROUP: {
      const { data } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          byCardGroup: data
        },
        loading: false
      };
    }
    case EventActionTypes.SET_EVENT_HIDDEN: {
      const id = action.payload;

      const byCardGroup = [...state.data.byCardGroup];
      const event = byCardGroup.find(ev => ev.id === id);

      if (event) {
        event.hidden = !event.hidden;
      }

      return {
        ...state,
        data: {
          ...state.data,
          byCardGroup
        },
        loading: false
      };
    }
    case EventActionTypes.HIDE_EVENTS: {
      const events = action.payload;

      const byId = { ...state.data.byId };

      events.forEach((ev: CardEvent) => {
        byId[ev.id] = ev;
      });

      return {
        ...state,
        data: {
          ...state.data,
          byId
        },
        loading: false
      };
    }
    case SharedActionTypes.RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export { reducer as EventReducer };



// WEBPACK FOOTER //
// ./src/store/events/reducer.ts